import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { CATEGORIES } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Shop() {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (category) params.category = category;
    api.get("/products", { params }).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [category]);

  const cat = CATEGORIES.find((c) => c.key === category);
  const filtered = products.filter((p) => p.name.toLowerCase().includes(query.toLowerCase()));

  return (
    <div data-testid="shop-page" className="mx-auto max-w-7xl px-6 py-10">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-sm text-fuchsia-600 font-medium">Ciara's Kidz{cat ? ` · ${cat.sub}` : ""}</p>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-purple-950 mt-1">
            {cat ? cat.label : "All Products"}
          </h1>
        </div>
        <div className="relative w-full sm:w-72">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            data-testid="shop-search-input"
            placeholder="Search products..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="pl-9 rounded-full bg-white"
          />
        </div>
      </div>

      {/* category pills */}
      <div className="flex flex-wrap gap-2 mb-8">
        <a href="/shop" className={`px-4 py-2 rounded-full text-sm font-medium border ${!category ? "brand-gradient text-white border-transparent" : "bg-white border-purple-200 text-purple-700"}`}>
          All
        </a>
        {CATEGORIES.map((c) => (
          <a
            key={c.key}
            href={`/shop/${c.key}`}
            data-testid={`shop-filter-${c.key}`}
            className={`px-4 py-2 rounded-full text-sm font-medium border ${category === c.key ? "brand-gradient text-white border-transparent" : "bg-white border-purple-200 text-purple-700 hover:bg-purple-50"}`}
          >
            {c.label}
          </a>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="aspect-[4/5] rounded-2xl bg-purple-50 animate-pulse" />
          ))}
        </div>
      ) : filtered.length === 0 ? (
        <p className="text-center text-muted-foreground py-20">No products found.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="shop-product-grid">
          {filtered.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
